import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { ComponentTypeResponse } from '@/types/apps/component-type.type';
import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface ComponentTypeGraphQLServiceInterface {}

type ComponentTypeGraphQLListResponse = GqlListResponse<ComponentTypeResponse>;

export class ComponentTypeGraphQLService
    extends BaseService
    implements ComponentTypeGraphQLServiceInterface
{
    public getEntityName(): string {
        return 'partType';
    }

    public getFields(): Record<string, any> {
        return {
            code: true,
            createdBy: true,
            createdDate: true,
            deletedAt: true,
            deletedBy: true,
            description: true,
            id: true,
            isDeleted: true,
            modifiedBy: true,
            modifiedDate: true,
            name: true,
            partCategoryCode: true,
            partCategoryId: true,

            partCategory: {
                code: true,
                id: true,
                name: true,
            },
        };
    }

    public async index(
        query: string
    ): Promise<ComponentTypeGraphQLListResponse> {
        return this.fetchGqlList<ComponentTypeGraphQLListResponse>(
            query,
            this.getEntityName()
        );
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById() || !this.getRoleTypeManager().getQuery) {
            return {};
        }

        return this.getRoleTypeManager().getQuery('componentType', {
            userId: this.getQueryById(),
        });
    }
}
